var $a35ddf99f17c1dd9$exports = {};
{
    const tables = document.querySelectorAll('.content__table');
    // Adds some basic mobile responsive fallbacks
    tables.forEach(function(table) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('wrapper', '-tableScroll');
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
}

//# sourceMappingURL=content.js.map
